import { MessagesScreen } from '../messages/MessagesScreen';

/** Trenerov popis razgovora sa svim klijentima — `/trener/poruke`. */
export function TrainerMessages() {
  return <MessagesScreen basePath="/trener/poruke" />;
}
